import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "src/components/ui/dialog";
import { Button } from "../../../../components/ui/button";
import { Eye } from "lucide-react";
import { useLanguage } from "../../../../context/LanguageContext";
import { UrlImage } from "../../../../lib/api";
import { SubLessonData } from "../../../../lib/languages";
import { parseField } from "../../../../lib/utils";

export default function DialogFilesAssignments({ item, children }) {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  return (
    <Dialog>
      <DialogTrigger>
        <>
          {children ? (
            children
          ) : (
            <Button variant="ghost" size="icon" className="h-7 w-7">
              <Eye />
            </Button>
          )}
        </>
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-[425px]"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader>
          <DialogTitle>{t.dialogFilesTitle}</DialogTitle>
          <DialogDescription>{t.dialogFilesDescription}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-2">
          {item.files && item.files.length > 0 ? (
            item.files.map((file, index) => (
              <a
                className="hover:underline"
                key={index}
                href={`${UrlImage}${file}`}
                download="myfile.pdf"
                target="_blank"
              >
                {parseField(item.title, language)}_{index + 1}.
                {file.split(".").pop()}
              </a>
            ))
          ) : (
            <p>{t.noFilesAvailable}</p>
          )}
        </div>
        <DialogClose asChild>
          <Button className="mt-4">{t.close}</Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
